__turbopack_context__.v({
  "brasserieScene": "MenuPage-module__xi3ZkG__brasserieScene",
  "brasserieSceneSalon": "MenuPage-module__xi3ZkG__brasserieSceneSalon",
  "brasserieSceneSheen": "MenuPage-module__xi3ZkG__brasserieSceneSheen",
  "brasserieSceneSignature": "MenuPage-module__xi3ZkG__brasserieSceneSignature",
  "brasserieSceneVignette": "MenuPage-module__xi3ZkG__brasserieSceneVignette",
  "categoryBar": "MenuPage-module__xi3ZkG__categoryBar",
  "categoryIndicator": "MenuPage-module__xi3ZkG__categoryIndicator",
  "categoryLink": "MenuPage-module__xi3ZkG__categoryLink",
  "categoryLinkActive": "MenuPage-module__xi3ZkG__categoryLinkActive",
  "categoryNav": "MenuPage-module__xi3ZkG__categoryNav",
  "ctaActions": "MenuPage-module__xi3ZkG__ctaActions",
  "ctaCard": "MenuPage-module__xi3ZkG__ctaCard",
  "ctaEyebrow": "MenuPage-module__xi3ZkG__ctaEyebrow",
  "ctaPrimary": "MenuPage-module__xi3ZkG__ctaPrimary",
  "ctaSecondary": "MenuPage-module__xi3ZkG__ctaSecondary",
  "ctaSection": "MenuPage-module__xi3ZkG__ctaSection",
  "ctaText": "MenuPage-module__xi3ZkG__ctaText",
  "ctaTitle": "MenuPage-module__xi3ZkG__ctaTitle",
  "eyebrow": "MenuPage-module__xi3ZkG__eyebrow",
  "hero": "MenuPage-module__xi3ZkG__hero",
  "heroContent": "MenuPage-module__xi3ZkG__heroContent",
  "heroDivider": "MenuPage-module__xi3ZkG__heroDivider",
  "heroText": "MenuPage-module__xi3ZkG__heroText",
  "heroTitle": "MenuPage-module__xi3ZkG__heroTitle",
  "heroWord": "MenuPage-module__xi3ZkG__heroWord",
  "highlightBadge": "MenuPage-module__xi3ZkG__highlightBadge",
  "highlightCard": "MenuPage-module__xi3ZkG__highlightCard",
  "highlightDescription": "MenuPage-module__xi3ZkG__highlightDescription",
  "highlightDetails": "MenuPage-module__xi3ZkG__highlightDetails",
  "highlightFooter": "MenuPage-module__xi3ZkG__highlightFooter",
  "highlightGrid": "MenuPage-module__xi3ZkG__highlightGrid",
  "highlightImage": "MenuPage-module__xi3ZkG__highlightImage",
  "highlightImageFrame": "MenuPage-module__xi3ZkG__highlightImageFrame",
  "highlightPrice": "MenuPage-module__xi3ZkG__highlightPrice",
  "highlightSection": "MenuPage-module__xi3ZkG__highlightSection",
  "highlightTitle": "MenuPage-module__xi3ZkG__highlightTitle",
  "menuGrid": "MenuPage-module__xi3ZkG__menuGrid",
  "menuGridReverse": "MenuPage-module__xi3ZkG__menuGridReverse",
  "menuHeading": "MenuPage-module__xi3ZkG__menuHeading",
  "menuItem": "MenuPage-module__xi3ZkG__menuItem",
  "menuItemDescription": "MenuPage-module__xi3ZkG__menuItemDescription",
  "menuItemDosage": "MenuPage-module__xi3ZkG__menuItemDosage",
  "menuItemHeader": "MenuPage-module__xi3ZkG__menuItemHeader",
  "menuItemNameGroup": "MenuPage-module__xi3ZkG__menuItemNameGroup",
  "menuItemPricing": "MenuPage-module__xi3ZkG__menuItemPricing",
  "menuItemRule": "MenuPage-module__xi3ZkG__menuItemRule",
  "menuItems": "MenuPage-module__xi3ZkG__menuItems",
  "menuSection": "MenuPage-module__xi3ZkG__menuSection",
  "page": "MenuPage-module__xi3ZkG__page",
  "priceAsterisk": "MenuPage-module__xi3ZkG__priceAsterisk",
  "storyBand": "MenuPage-module__xi3ZkG__storyBand",
  "storyContent": "MenuPage-module__xi3ZkG__storyContent",
  "storyGrid": "MenuPage-module__xi3ZkG__storyGrid",
  "storyImageFrame": "MenuPage-module__xi3ZkG__storyImageFrame",
  "storyLabel": "MenuPage-module__xi3ZkG__storyLabel",
  "storyText": "MenuPage-module__xi3ZkG__storyText",
  "storyTitle": "MenuPage-module__xi3ZkG__storyTitle",
  "takeawayIcon": "MenuPage-module__xi3ZkG__takeawayIcon",
  "takeawayStatus": "MenuPage-module__xi3ZkG__takeawayStatus",
  "ttcAsteriskIcon": "MenuPage-module__xi3ZkG__ttcAsteriskIcon",
  "ttcCard": "MenuPage-module__xi3ZkG__ttcCard",
  "ttcLine": "MenuPage-module__xi3ZkG__ttcLine",
  "ttcNotice": "MenuPage-module__xi3ZkG__ttcNotice",
  "ttcText": "MenuPage-module__xi3ZkG__ttcText",
});
